module.exports = "/dist/montserrat-latin-600.svg?e191570672926bc15d59883e57649ff7";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-600.svg
// module id = 76
// module chunks = 0